// The Empirio server's AI endpoints (/api/chat and friends) only answer signed-in users: every request must carry the
// Supabase session's access token. Most callers used to send no token, so since May 2026 the server refused them
// and children saw "Lumi had trouble connecting" (writing feedback, Lumi chat, study planner, parent summaries).
import { supabase, supabaseEnabled } from './supabase';

export async function authHeaders() {
  if (!supabaseEnabled) return {};
  try {
    const { data } = await supabase.auth.getSession();
    const t = data?.session?.access_token;
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch (_) { return {}; }
}
